define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi/def/Action",
	"csi/def/ViewRef",
	"csi/heading/AttributeAction",
	"csi/xml"
], function(declare, lang, Action, ViewRef, AttributeAction, xml) {

	return declare(AttributeAction, {
		constructor: function(def) {
			this.classController = "csi.heading.CommentController";
			this.m_id = "ActionComment";
			this.m_right = xml.RIGHT_WRITE;
		},

		/**
		 * @override
		 * Comments should always be considered inline editable.
		 */
		hasAccess: function(ctx) {
			return Action.prototype.hasAccess.call(this, ctx);
		},

		checkNodeAccess: function(/*Node*/node) {
			var rca = this.heading._rca;
			return xml.nodeHasAccess(node, this.m_right) && rca && !rca.isCommentRestricted;
		}
	});
});